<template>
  <div class="article">
    <div class="inner-content mt-5" v-if="article.title.rendered">
      <div class="article-header">
        <div class="article-meta">
          <time :datetime="article.date" class="pubdate subheading font-weight-bold">{{ formatDate(article.date) }}</time>
          <h1
            :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline'"
            class="primary--text"
            v-html="article.title.rendered"
          ></h1>
        </div>
      </div>

      <Content class="event-content" :content="content" v-if="content.length > 0"></Content>
      <div class="article-content" v-html="article.content.rendered" v-else></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers.js'
import Content from '@/components/Utils/Content.vue'

export default {
  name: 'Article',

  components: { Content },

  mounted () {
    this.fetchArticle()
  },

  methods: {
    formatDate,
    fetchArticle () {
      this.$store.commit('setLoading', true)
      if (this.$route.name === 'nc-campaign-article') {
        this.$store.dispatch('getNCArticle', this.$route.params.articleSlug).finally(() => {
          this.$store.commit('setLoading', false)
        })
      } else {
        this.$store.dispatch('getArticle', this.$route.params.slug).finally(() => {
          this.$store.commit('setLoading', false)
        })
      }
    }
  },

  computed: {
    ...mapGetters(['route', 'article']),
    content () {
      return this.article.content_alt ? this.article.content_alt.content : []
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearHero')
    next()
  }
}
</script>

<style lang="scss">
.article-header {
  margin-bottom: 2rem;
}
</style>
